export enum ImportType {
  LOCAL = "local",
  WEBHOOK = "webhook",
  FILE_UPLOAD = "file-upload",
}
